/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useIntl } from '@exo/frontend-common-i18n';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ResetPasswordResponse } from '../../../../../polaris-login/polaris-login-ui/client/components/ForgotPasswordResponse/ForgotPasswordResponse';
import { AuthEndpointsConfig } from '../../authConfig';

export const EnterCodeSuccessPage = ({ authConfig }: Props) => {
  const location = useLocation();
  const isVerifying = location.state;
  const intlPrefix = isVerifying ? 'NewUserVerificationSuccessPage' : 'EnterCodeSuccessPage';
  const intl = useIntl(`features.polaris-login.polaris-login-ui.pages.${intlPrefix}`);

  const handleContinue = () => {
    window.location.href = `${authConfig.mainAppUrl}/account/login`;
  };
  return (
    <ResetPasswordResponse
      title={intl.msg('page.top.title', 'Forgotten Password') as string}
      subtitle={intl.msg('page.top.subtitle', '') as string}
      text={intl.msg('page.body.text', '') as string}
      rightButtonLabel={intl.msg('page.bottom.button.continue', 'Continue') as string}
      rightButtonFn={handleContinue}
    />
  );
};

type Props = {
  authConfig: AuthEndpointsConfig;
};
